import { defineCopy } from '@floorfile/i18n'
import { ncrCopy } from './copy'

export const ncrOfflineCopy = defineCopy('ncr', { offlineAction: ncrCopy.en.offlineAction })
